import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectFinancialYear = createSelector(
  [selectConfigurationState],
  ({ data }) => data.fYear
)
